import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-maximum-driver-close",
  "use": "icon-maximum-driver-close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-maximum-driver-close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.286 4.107a.833.833 0 1 0-1.179 1.179L8.821 10l-4.714 4.714a.833.833 0 1 0 1.179 1.178L10 11.178l4.714 4.714a.833.833 0 0 0 1.178-1.178L11.178 10l4.714-4.714a.833.833 0 0 0-1.178-1.179L10 8.821 5.286 4.107Z\" fill=\"#7F8596\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol